module.exports = __webpack_public_path__ + "img/dipendenti_smartform.bd5633cb.png";